export default "__VITE_ASSET__DGMdE4Ah__"